import { withInstall } from '@zoryn/utils'
import Text from './src/text.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZText: SFCWithInstall<typeof Text> = withInstall(Text)
export default ZText

export * from './src/text'
